<template>
<div> <!-- root element start -->
	<div class="row">
		<div class="col-12">
      <div v-if="userDetailsComp == 0" class="card border-0">
          <div class="card-body">

            <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>

          </div>
      </div>
			<div v-if="userDetailsComp == 1" class="card border-0 mb-3">
			    <div class="card-body pb-1 pl-0">
            <div class="row">
              <div class="col-12">
                <div class="h3 text-muted">{{ time | getGreetingTime }}, {{ userDetails.f_name }} {{ userDetails.l_name }}!</div>
              </div>
            </div>

			    </div>
			</div>
		</div>
	</div>
</div> <!-- root element end -->
</template>

<style>
.vuetable :focus { outline:none; }
</style>

<script>
import { ScalingSquaresSpinner } from 'epic-spinners'
import {store} from '../../stores/bm-dashboard-main-store.js'




export default {
  store,
  data: function () {
    return {
      detailUrl: '/organization-detail/',

    }
  },
  computed: {
    userDetails() { return this.$store.state.userDetails; },
    userDetailsComp() { return this.$store.state.userDetailsComp; },
    time() { return moment(); }
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    changeRightView(name, prop1, prop2, prop3) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2, prop3: prop3 }); },


    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-create':
        _this.getAllProducts();
        _this.changeRightView('product-list', '', '', '');
        break;

        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-create':
          _this.changeRightView('product-list', '', '', '');
        break;

        default:
      }
    },

  },
  components:{
    ScalingSquaresSpinner,

  },
  filters: {
    getGreetingTime(currentTime) {
      if (!currentTime || !currentTime.isValid()) { return 'Hello'; }

      const splitAfternoon = 12; // 24hr time to split the afternoon
      const splitEvening = 17; // 24hr time to split the evening
      const currentHour = parseFloat(currentTime.format('HH'));

      if (currentHour >= splitAfternoon && currentHour <= splitEvening) {
        // Between 12 PM and 5PM
        return 'Good Afternoon';
      } else if (currentHour >= splitEvening) {
        // Between 5PM and Midnight
        return 'Good Evening';
      }
      // Between dawn and noon
      return 'Good Morning';
    }
  }
}
</script>
